import { NavLink } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { slugify } from './helpers';

const Product = ({ product }) => {
  const { logo: Logo, name, description, product: Product } = product;
  const { formatMessage } = useIntl();

  return (
    <div className='product'>
      <Logo />
      <h4 className='product__title'>{name}</h4>
      <p className='product__description'>{description}</p>
      <NavLink to={`/integrations/${slugify(name)}/details?product=${Product}`} className='product__link'>
        {formatMessage({ id: 'Go to' })}
      </NavLink>
    </div>
  );
};

export default Product;
